import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { user } from '../model/user.fragments';
import { UserOutput } from '../model/user.output';

export interface UpdateUserLanguageParams {
	readonly language: string;
}

@Injectable({ providedIn: 'root' })
export class UpdateUserLanguageApiMutation extends ApiMutation<
	UserOutput,
	UpdateUserLanguageParams
> {
	client = 'iam';
	document = gql`
		mutation UpdateUserLanguage($language: String!) {
			updateUserLanguage(language: $language) {
				...User
			}
		}
		${user}
	`;
	method = 'updateUserLanguage';
}
